import React from 'react';
import { Card } from 'semantic-ui-react';
import { CardComposer } from '../cards/CardComposer';
import { CardProfile } from '../cards/CardProfile';
import { CardSong } from '../cards/CardSong';
import { CardSongCycle } from '../cards/CardSongCycle';
import { CardPlace } from '../cards/CardPlace';
import { CardTextAuthor } from '../cards/CardTextAuthor';



export const Result = ({ data, alias, query }) => {
  const matchedQueries = !query || query === '*' ? [] : (data.matched_queries || []);
  let out = (<React.Fragment />);
  switch (alias) {
    case 'songs':
      return (<CardSong data={data._source} id={data._source.id}  matchedQueries={matchedQueries} />);
    case 'song_cycles':
      return (<CardSongCycle data={data._source} id={data._source.id} matchedQueries={matchedQueries} />);
    case 'pitches':
    case 'instruments':
    case 'places':
      return (<CardPlace data={data._source} id={data._source.id} matchedQueries={matchedQueries} />);
    case 'composers':
      return (<CardComposer data={data._source} id={data._source.id} matchedQueries={matchedQueries} />);
    case 'profiles':
      return (<CardProfile data={data._source} id={data._source.id} matchedQueries={matchedQueries} />);
    case 'arrangers':
    case 'text_authors': 
      return (<CardTextAuthor data={data._source} id={data._source.id} matchedQueries={matchedQueries} />);
    case 'instrument_kinds':
      break;
  }
  return out;
};